module.exports = __webpack_public_path__ + "img/image-company.3d592e87.png";